import React from 'react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import './landingPage2.scss';
import { WorkerRegistrationStore } from '../../stores/WorkerRegistrationStore';
import { resources } from '../../resources/strings';
import { ClientTrackingNames } from '../../models/ClientTracking';
import {ConfigService} from "../../services/ConfigService";

interface IProps {
    workerRegistrationStore: WorkerRegistrationStore;
}

function LandingPage2(props: IProps){
    props.workerRegistrationStore.hideHeader();
    const strings = resources.landingPage2;

    React.useEffect(() =>
            props.workerRegistrationStore.clientTracking.trackRender(
                ClientTrackingNames.Landing,
                {page: 2}),
        []
    );

    const configs = ConfigService.getInstance().values;
    const constants = configs.constants;
    const findMoreLink = constants.WEBSITE_LINK;

    return(
        <div className='landing-page-2'>
            <div className='content-container'>
                <div className='logo-container' />
                <div className='text-container'>
                    {
                        strings.content.map((item: string, index: number) => (<p key={index}>{item}</p>))
                    }
                </div>
                <div className='action-container'>
                    <Link className='register-button'
                          to={'/sign-up'}>
                        <Button className='button register-button'>{strings.registerButtonLabel}</Button>
                    </Link>
                    <a className='find-out-more' href={findMoreLink}>
                        {strings.findOutMoreLabel}
                    </a>
                </div>
            </div>
        </div>
    )
}

export default LandingPage2;
